import React from 'react';
import { FiX } from 'react-icons/fi';
import { trackEvent } from '../utils/tracking';

const SampleCart = ({
  selectedSamples,
  onRemoveSample,
  onRequestAllSamples,
  onClearCart
}) => {
  const totalSamples = selectedSamples.length;

  const handleRequestAll = () => {
    if (totalSamples > 0) {
      trackEvent('checkout_click', {
        source: 'cart_panel',
        sample_count: totalSamples
      });
      onRequestAllSamples(selectedSamples);
    }
  };

  const handleClearCart = () => {
    if (totalSamples > 0) {
      trackEvent('clear_cart', { sample_count: totalSamples });
      onClearCart();
    }
  };

  if (totalSamples === 0) {
    return (
      <div className="sample-cart empty">
        <div className="cart-icon">🛒</div>
        <p className="empty-message">No samples selected</p>
        <p className="empty-subtitle">Click the checkbox on materials to add them to your sample cart</p>
      </div>
    );
  }

  return (
    <div className="sample-cart">
      <div className="cart-header">
        <h3 className="cart-title">Sample Cart</h3>
        <span className="cart-count">{totalSamples} {totalSamples === 1 ? 'sample' : 'samples'}</span>
      </div>

      <div className="cart-items">
        {selectedSamples.map((sample, index) => (
          <div key={`${sample.id}-${index}`} className="cart-item">
            <div className="item-thumbnail">
              <img src={sample.thumbnail} alt={sample.name} />
            </div>
            <div className="item-details">
              <h4 className="item-name">{sample.name}</h4>
              <p className="item-category">{sample.category}</p>
            </div>
            <button
              className="remove-btn"
              onClick={() => onRemoveSample(sample.id)}
              title="Remove from cart"
            >
              <FiX size={16} />
            </button>
          </div>
        ))}
      </div>

      <div className="cart-actions">
        <button
          className="clear-cart-btn"
          onClick={handleClearCart}
          disabled={totalSamples === 0}
        >
          Clear Cart
        </button>
        <button
          className="request-all-btn"
          onClick={handleRequestAll}
          disabled={totalSamples === 0}
        >
          Checkout
          <span className="checkout-count">{totalSamples}</span>
        </button>
      </div>
    </div>
  );
};

export default SampleCart;
